import React, { useEffect, useState } from "react";
import styles from "./Hero.module.css";
import dark from "./HeroDark.module.css";
import { Button, Col, Progress, Row } from "antd";
import { Link } from "react-router-dom/dist";
import axios from "axios";

//replace ABI!

const Hero = ({ theme }) => {
  
  
  const [length, setLength] = useState(0)
  const [supply, setSupply] =useState(0)

  useEffect(() => {  
 
}, []);

  useEffect(() => {  
  
    const getNfts = async () => {
      // mainnet
      // Replace this with the dos punk contract!
      const prefix =
        "https://eth-mainnet.g.alchemy.com/nft/v3/nLeTw4kEJZvFG5VNZY1TmgVXeI6cTdBM/getNFTsForCollection?contractAddress=0x495f947276749ce646f68ac8c248420045cb7b5e&limit=200";
      const {data} = await axios.get(prefix);
      setLength(data?.nfts.length)
    };
    getNfts();
  }, []);
  
  //need to change this to mainnet contract
  useEffect(() => {  
  
    const getTokenBalance = async () => {
      // mainnet
      // Replace this with the dos punk contract!
      const prefix =
        "https://eth-mainnet.g.alchemy.com/nft/v3/nLeTw4kEJZvFG5VNZY1TmgVXeI6cTdBM/getContractMetadata?contractAddress=0x0Aa480688025A018EBA2FE8474D5Ca545de8e9a0";
      const {data} = await axios.get(prefix);
      setSupply(data?.totalSupply)
     
    };
    getTokenBalance()
    
  }, []);

  

  return (
    <Row
      className={theme ? styles.dospunks_container : dark.dospunks_container}
    >
      <Col md={12} className={styles.dospunks_left}>
        <div>
          <h1>About</h1> <br />
          <p className={styles.dospunks_p}>
            DOS Punks is a collection of 1000 collectibles, half on the Tezos
            blockchain and half on the Ethereum blockchain. Each punk is made
            with a DOS character set and various retro-gaming/computing color
            palettes.
          </p>
        </div>
        <div className={styles.progressRow}>
          <div>
            <span
              style={{
                color: theme ? "#f0f0f0" : "#f0f0f0",
              }}
            >
              {supply}/500 Migrated
            </span>
          </div>{" "}
          <br />
          <div style={{ width: "90%" }}>
            <Progress
              type="line"
              trailColor={theme ? "#D9D9D9" : "#555"}
              strokeLinecap="butt"
              strokeColor={theme ? "#333" : "white"}
              showInfo={false}
              size={[ , 40]}
              percent={Math.floor(supply/500 *100)}
            />
          </div>
        </div>
        <div>
          <Link to={"/migration"}>
            {" "}
            <Button className={theme ? styles.migrate_btn : dark.migrate_btn}>
              MIGRATE
            </Button>{" "}
          </Link>
        </div>
      </Col>

      <Col md={12}>
        <div className={styles.daoimg}>
          <img
            src="https://www.dospunks.xyz/images/gifs/827_3-glitch.gif"
            alt=""
          />
        </div>
        {/* <Row className={styles.imagesRow} gutter={[32, 32]}>
          <Col xs={12} md={12}>
            <img className={styles.image} src="../images/1.png" alt="" />
          </Col>
          <Col xs={12} md={12}>
            <img className={styles.image} src="../images/2.png" alt="" />
          </Col>
          <Col xs={12} md={12}>
            <img className={styles.image} src="../images/3.png" alt="" />
          </Col>
          <Col xs={12} md={12}>
            <img className={styles.image} src="../images/4.png" alt="" />
          </Col>
        </Row> */}
      </Col>
    </Row>
  );
};

export default Hero;
